import { all } from 'redux-saga/effects';

import atendimentos from './atendimentos/combineSaga';

export default all([atendimentos]);
